import Chart from "react-apexcharts";

export default function Grafico(props) {
  /*const [chartData, setChartData] = useState({
    options: {
      chart: {
        id: "apexchart-example",
      },
      xaxis: {
        categories: props.categories,
      },
    },
    series: [
      {
        name: props.serie,
        data: props.data,
      },
    ],
  });*/

  /*
  useEffect(() => {
    fetch(
      "https://bookstore-v2-api.vercel.app/api/v1/analytics/revenue/lifetime"
        .then(response => response.json()
        .then(data => console.log(data))
        .catch(err => console.log(err))
    );
    setChartData(...chartData, {
      series: [
        {
          name: props.serie,
          data: props.data,
        },
      ],
    });
  }, []);
*/

  /*
  console.log("PROPS: ", props);
  console.log("PROPS.OPTIONS: ", props.options);
  console.log("PROPS.SERIES: ", props.series);
*/

  return (
    <div>
      <Chart
        options={props.options}
        series={props.series}
        type={props.type}
        width={"100%"}
        height={350}
      />
    </div>
  );
}
